import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ItemOnlineReportContent from './ItemOnlineReportContent';
import { setFromDate, setToDate, setSelectedBranch, fetchItemOnlineFullReport } from './itemOnlineReportSlice';

const ItemOnlineReportAdmin = () => {
    const dispatch = useDispatch();
    const storedBranchId = localStorage.getItem('branchid') || '';

    useEffect(() => {
        const toDate = new Date();
        const fromDate = new Date();
        fromDate.setDate(fromDate.getDate() - 30);
        dispatch(setFromDate(fromDate));
        dispatch(setToDate(toDate));
        dispatch(setSelectedBranch({ branch_id: storedBranchId || 'All', branch_name: 'Branch' }));
        dispatch(
            fetchItemOnlineFullReport({
                fromDate,
                toDate,
                branchId: storedBranchId || 'All'
            })
        );
    }, [dispatch, storedBranchId]);

    return <ItemOnlineReportContent />;
};

export default ItemOnlineReportAdmin;
